import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ScheduleService} from '../services/ScheduleService';
import {AssignmentService} from '../services/AssignmentService';
import {FormService} from '../services/FormService';
import {AssignmentsScheduleMainSettingsComponent} from './schedule/main-settings';
import {AssignmentScheduleDueTimeComponent} from './schedule/due-time';
import {AssignmentsScheduleOverdueComponent} from './schedule/overdue';
import {ProgressBar} from 'primeng/progressbar';

@Component({
  selector: 'ng-assignments-schedule',
  templateUrl: './assignments-schedule.html',
  imports: [
    AssignmentsScheduleMainSettingsComponent,
    AssignmentScheduleDueTimeComponent,
    AssignmentsScheduleOverdueComponent,
    ProgressBar
  ]
})
export class AssignmentsSchedule implements OnInit, OnDestroy {

  private subs: Subscription[] = [];

  constructor(
    public fsvc: FormService,
    public ssvc: ScheduleService,
    public asvc: AssignmentService,
  ) {
  }

  ngOnInit() {
    this.subs.push(this.asvc.OnChainChanged.subscribe({next: () => this.ssvc.Load()}))
    this.subs.push(this.asvc.OnBranchChanged.subscribe({next: () => this.ssvc.Load()}))
    this.ssvc.Load();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
